import { __rest } from '../../node_modules/tslib/tslib.es6.js';
import { jsx } from 'react/jsx-runtime';
import { StyledBadge } from './badge.style.js';

const Badge = props => {
    const { backgroundColor = 'primaryInverse', backgroundless = false, className = '', children, margin, color, size = 'medium' } = props, rest = __rest(props, ["backgroundColor", "backgroundless", "className", "children", "margin", "color", "size"]);
    const showChildren = size !== 'xsmall';
    return (jsx(StyledBadge, Object.assign({ backgroundColor: backgroundColor, backgroundless: backgroundless, className: className, margin: margin, color: color, size: size }, rest, { children: showChildren && children }), void 0));
};

export { Badge };
